var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 사입 확정화면? "),(_vm.purchase)?_c('div',[_vm._v(" "+_vm._s(_vm.purchase)+" "),_c('v-btn',{on:{"click":function($event){return _vm.confirm(_vm.purchase)}}},[_vm._v("확정하기")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }